import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash-es';

@Pipe({ name: 'orderBy', standalone: true })
export class OrderByPipe<T> implements PipeTransform {
  public transform(value: T[], column: keyof T, ascending = true): T[] {
    if (!value || value.length == 0) {
      return value;
    }
    return orderBy(
      value,
      [
        item =>
          typeof item[column] == 'string'
            ? (<string>item[column]).toLowerCase()
            : item[column],
      ],
      [ascending ? 'asc' : 'desc'],
    );
  }
}
